
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selector/[...config]",
      function () {
        return require("private-next-pages/selector/[...config].tsx");
      }
    ]);
  